import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          Nothing to see here, I am just having fun with react and deployment
        </p>
        <a
          className="App-link"
          href="https://github.com/nicksemin"
          target="_blank"
          rel="noopener noreferrer"
        >
          Check my github!
        </a>
      </header>
    </div>
  );
}

export default App;
